"use client";
// Imports
import { ComponentWrapper } from "@/components";
import { cn } from "@/lib/utils";

const SPACING_TOP = {
  none: "pt-0",
  small: "pt-3 lg:pt-4",
  medium: "pt-6 lg:pt-10",
  large: "pt-10 lg:pt-16",
  extra_large: "pt-16 lg:pt-24",
};

const SPACING_BOTTOM = {
  none: "pb-0",
  small: "pb-3 lg:pb-4",
  medium: "pb-6 lg:pb-10",
  large: "pb-10 lg:pb-16",
  extra_large: "pb-16 lg:pb-24",
};

function resolveSpacingValue(spacing) {
  if (!spacing) return "medium";
  return typeof spacing === "object" ? spacing.value : spacing;
}

function itemBasisClass(count) {
  if (count <= 1) return "basis-full max-w-md mx-auto";
  if (count === 2) return "basis-full sm:basis-1/2";
  if (count === 3) return "basis-full sm:basis-1/2 lg:basis-1/3";
  if (count === 4) return "basis-full sm:basis-1/2 lg:basis-1/4";
  return "basis-full sm:basis-1/2 lg:basis-1/5";
}

// Stats Band — full-width red gum strip with 1–5 centred callouts
export function StatsBand({ type, items = [], spacingTop, spacingBottom }) {
  const stats = items.filter((item) => item?.title || item?.text);
  if (!stats.length) return null;

  const topKey = resolveSpacingValue(spacingTop);
  const bottomKey = resolveSpacingValue(spacingBottom);
  const basis = itemBasisClass(stats.length);

  return (
    <ComponentWrapper
      type={type}
      className={cn(
        SPACING_TOP[topKey] ?? SPACING_TOP.medium,
        SPACING_BOTTOM[bottomKey] ?? SPACING_BOTTOM.medium
      )}
    >
      <div className="w-full bg-brand-red-gum text-brand-wool">
        <div className="mx-auto w-full max-w-8xl px-4 py-10 sm:px-6 sm:py-12 lg:px-10 lg:py-16">
          <div className="flex flex-col sm:flex-row sm:flex-wrap lg:flex-nowrap justify-center items-stretch gap-y-8 sm:gap-y-10 lg:gap-x-4">
            {stats.map((item, index) => (
              <div
                key={item?.id ?? index}
                className={cn(
                  "flex flex-col items-center justify-start text-center px-3 sm:px-4 lg:px-2 lg:flex-1 lg:min-w-0",
                  basis
                )}
              >
                {item?.title && (
                  <h2 className="font-heading !font-normal text-[clamp(1.5rem,2.5vw+0.85rem,2.5rem)] leading-none tracking-tight">
                    {item.title}
                  </h2>
                )}
                {item?.text && (
                  <p className="font-body font-normal text-md lg:text-lg leading-snug mt-2 sm:mt-3 max-w-[14rem] sm:max-w-[16rem] lg:max-w-[12rem] xl:max-w-[14rem]">
                    {item.text}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </ComponentWrapper>
  );
}
